

import { callApi } from "./API";

function resendInvite(email) {
    const domain = window.API_DASHBOARD_DATA;
    callApi(domain, {
      type: "resendInvitation",
      userEmail: email,
    }).then((data) => {
    }).catch((error) => {
        // Handle the error response here
        console.error("An error occurred while resending the invitation:", error);
    });;
}
console.log('window.location.pathname',window.location.pathname);

async function removeFromCompany(id,statusOfInvitation) {
  const domain = window.API_DASHBOARD_DATA;
  try  {
    const response = await callApi(domain, {
      type: "removeFromCompany",
      // parentId: 2974,
      userId: id,
      statusOfInvitation:statusOfInvitation
    })
    return true
  }catch (error){
    console.log('error.message---> ',error.message);
    
    return false
  }
}
export { resendInvite ,removeFromCompany  };